<template>
	<div class="settings">
		<div class="jumbotron">
			<div class="container">
				<h1 class="display-3">Podešavanja</h1>
				<p>Opšti podaci o firmi i računima.</p>
			</div>
		</div>

		<div class="container">
			<form>
				<h4 class="mb-3">Firma</h4>

				<div class="form-row">
					<div class="form-group col-md-8">
						<label>Naziv</label>
						<input type="text" v-model="settingState.company.name" class="form-control">
						<small class="form-text text-muted">Pun naziv firme.</small>
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-6">
						<label>Adresa</label>
						<input type="text" v-model="settingState.company.address" class="form-control">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-6">
						<label>Vlasnik</label>
						<input type="text" v-model="settingState.company.owner" class="form-control">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-4">
						<label>PIB</label>
						<input type="text" v-model="settingState.company.taxNumber" class="form-control">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-4">
						<label>Matični broj</label>
						<input type="text" v-model="settingState.company.registrationNumber" class="form-control">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-4">
						<label>Šifra delatnosti</label>
						<input type="text" v-model="settingState.company.classificationCode" class="form-control">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-6">
						<label>Tekući račun</label>
						<input type="text" v-model="settingState.company.bankAccount" class="form-control">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-6">
						<label>Odgovorno lice</label>
						<input type="text" v-model="settingState.company.responsiblePerson" class="form-control">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-4">
						<label>Telefon</label>
						<input type="text" v-model="settingState.company.phoneNumber" class="form-control">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-4">
						<label>Web</label>
						<input type="text" v-model="settingState.company.website" class="form-control">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-4">
						<label>Email</label>
						<input type="text" v-model="settingState.company.email" class="form-control">
					</div>
				</div>

				<hr class="mb-4">

				<h4 class="mb-3">Računi</h4>

				<div class="form-row">
					<div class="form-group col-md-4">
						<label>Podrazumevano mesto izdavanja</label>
						<input type="text" v-model="settingState.invoice.defaultIssuePlace" class="form-control">
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-md-4">
						<label>Podrazumevani rok za plaćanje</label>
						<input type="number" min="1" v-model="settingState.invoice.defaultPaymentDeadline" class="form-control">
					</div>
				</div>

				<hr class="mb-4">

				<button type="button" class="btn btn-primary" @click="save">Sačuvaj</button>
			</form>
		</div>
	</div>
</template>

<script>
import { settingStore } from '../stores/settings';

export default {
	name: 'settings',

	data() {
		return {
			settingState: settingStore.state
		};
	},

	methods: {
		save() {
			settingStore.update(this.settingState)
				.then(() => {
					this.$toasted.success('Sačuvane izmene podešavanja.', {
						icon: 'done'
					});
				})
				.catch((error) => {
					this.$toasted.error('Nije uspelo čuvanje izmena podešavanja. ' + error.toString(), {
						icon: 'error_outline'
					});
				});
		}
	}
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Settings.vue?8fe4b60a